import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { useState, useEffect } from 'react';
import { Button } from './Button';
import * as cookies from 'react-cookies';

export interface Props {
  adminDomainUrl: string;
  contentPath: string;
}

export function AdminBannerActivate() {
  useEffect(() => {
    cookies.save('IrhjUTUTnB', 'RAD6YwnIpj');
  }, []);

  return <></>;
}
